<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-alarm-clock"></i> 证书预约
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- <div class="handle-box">
			<router-link to="consultsadd">
				<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			>添加</el-button></router-link>
        </div>-->
        <div class="container">
            <el-table
                :data="listAppointmentData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="createTimeStr" label="申请时间"></el-table-column>
                <el-table-column prop="areaName" label="区域"></el-table-column>
                <el-table-column prop="applicantName" label="姓名"></el-table-column>
                <el-table-column prop="cellphoneNumber" label="电话"></el-table-column>
                <el-table-column prop="statusStr" label="状态"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status == 1"
                            type="text"
                            @click="changeStatusfun(scope.row)"
                        >处理</el-button>
                        <el-button
                            v-else-if="scope.row.status == 2"
                            style="color: rgb(153, 153, 153);"
                            type="text"
                        >处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>




<script>
import { listAppointmentInformations, changeStatus } from '@/api/index'; // 导入我们的api接口

export default {
    name: 'ordercertificate',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            }, //分页
            pageTotal: 0, //数据总条数
            listAppointmentData: [] //列表数据
        };
    },
    created() {
        var that = this;
        // 列表数据
        this.getlistAppointmentInformations();
    },
    methods: {
        // 获取列表数据
        getlistAppointmentInformations() {
            listAppointmentInformations({
                current: this.query.pageIndex,
                size: this.query.pageSize,
                kind: 2
            }).then(res => {
                // 获取数据成功后的其他操作
                this.listAppointmentData = res.data.records;
                this.pageTotal = res.data.total;
            });
        },

        // 删除操作
        changeStatusfun(row) {
            // 二次确认删除
            this.$confirm('确定要处理此数据吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    changeStatus(
                        {},
                        {
                            appointmentInformationId: row.appointmentInformationId
                        }
                    ).then(res => {
                        this.query.pageIndex = 1;
                        this.getlistAppointmentInformations();
                        if (res.code == 0) {
                            // 获取数据成功后的其他操作
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                        } else if (res.code == 1) {
                            this.$message({
                                message: res.message,
                                type: 'warning'
                            });
                        } else {
                            this.$message({
                                message: '报错啦!',
                                type: 'warning'
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistAppointmentInformations();
        }
    }
};
</script>

<style scoped>
.handle-box {
    height: 32px;
    line-height: 32px;
    margin-bottom: 10px;
}
.handle-add {
    float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title {
    border-left: 4px solid #409eff;
    font-size: 16px;
    text-indent: 10px;
    margin-bottom: 20px;
}

.see-list p {
    /* line-height: 32px; */
    margin-bottom: 20px;
    letter-spacing: 1px;
    font-size: 14px;
    text-indent: 15px;
}
</style>
<style>
.branch-dialog .el-dialog__header {
    background: #409eff;
    padding: 10px 20px;
}
.branch-dialog .el-dialog__header .el-dialog__title {
    color: #fff;
}
.branch-dialog .el-dialog__header .el-dialog__headerbtn {
    background: #409eff;
    top: 12px;
}
.branch-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
}
.branch-dialog .el-dialog__body {
    height: 50vh;
    overflow-y: scroll;
    padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label {
    /* text-align: left; */
    width: 130px;
}
.branch-dialog .el-form-item__content {
    margin-left: 130px;
}

.branch-area {
    position: relative;
    height: 32px;
    line-height: 32px;
    margin-bottom: 4px;
}
.branch-area span {
    display: block;
    width: 118px;
    text-align: right;
}
.branch-area span::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
.branch-area i {
    position: absolute;
    top: 7px;
    right: 0;
    font-size: 20px;
    cursor: pointer;
}
.branch-areaitem {
    position: relative;
}
.branch-areaitem .el-cascader {
    width: 90%;
}
.branch-areaitem b {
    position: absolute;
    top: 7px;
    right: 0;
    font-size: 20px;
    cursor: pointer;
}
.branch-password .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
</style>
